import './Automotriz.css';
import React from "react";
import Automotriz0 from '../../assets/Industries/Automotriz/Automotriz0.png';
import Automotriz1 from '../../assets/Industries/Automotriz/Automotriz1.png';

const images = [
    { src: Automotriz1, text: "Yutong bus" },
];

function Automotriz() {
    return (
        <div className="arquitectura-container">
            <div className="arquitectura-header">
                <div className="arquitectura-texto">
                    <h2>Automotriz</h2>
                    <div className="underline"></div>
                    <p>
                        Seguridad, protección del medio ambiente y confianza es lo que podemos ofrecer a los clientes. Los actuales productos selladores "Blue Tak" de Zhengzhou Zhongyuan se han utilizado ampliamente en Mercedes-Benz, BMW, Volkswagen, General, Yutong y otras marcas conocidas en el país y en el extranjero. para que cada automóvil proporcione productos selladores más confiables y respetuosos con el medio ambiente.
                    </p>
                </div>
                <div className="arquitectura-imagen">
                    <img src={Automotriz0} alt="Arquitectura" />
                </div>
            </div>

            <div className="arquitectura-grid">
                {images.map((item, index) => (
                    <div key={index} className="arquitectura-item">
                        <img src={item.src} alt={`Arquitectura ${index + 1}`} />
                        <p>{item.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Automotriz;
